import React from 'react';
import Datetime from '../utils/Datetime'

export default function(props) {
    return (
        <React.Fragment>
            <h4>{props.performance.name}</h4>
            <p dangerouslySetInnerHTML={{__html: props.performance.description}} className='text-block' />
            <p>
                <Datetime datetime={props.performance.datetime} />
                <br />
                {props.performance.hall}
            </p>
        </React.Fragment>
    );
}
